/**
 * Bridges the mounted {@link Chat} instance's imperative controls to surfaces
 * that live outside its React subtree (e.g. the sidebar thread list). The
 * active `useChat` `stop` function is registered on mount so external actions
 * — like deleting the thread that is currently streaming — can abort the
 * in-flight supervisor stream instead of silently orphaning it.
 */

let stopFn: (() => void) | null = null;

/** Registered by the mounted Chat instance; cleared on unmount. */
export const registerStop = (fn: (() => void) | null) => {
  stopFn = fn;
};

/** Aborts the in-flight supervisor stream, if any. Safe to call anytime. */
export const stopActiveStream = () => {
  stopFn?.();
};
